module.exports = __webpack_public_path__ + "static/media/beauty-big.a74492fd.png";